<template>
  <div>
    <div class="page-header">
      <div class="line"></div>
      <div class="page-title">财务管理</div>
    </div>
    <!-- 财务概览卡片 -->
    <div class="financial-overview">
      <div class="overview-card">
        <div class="card-content">
          <div class="card-amount">{{ FinancialData.total_income }}</div>
          <div class="card-title">店铺总收入 (元)</div>
        </div>
      </div>
      <div class="overview-card">
        <div class="card-content">
          <div class="card-amount">{{ FinancialData.store_money }}</div>
          <div class="card-title">可用余额 (元)</div>
          <div class="withdraw-btn" @click="handleClick('1')">提现</div>
        </div>
      </div>
      <div class="overview-card">
        <div class="card-content">
          <div class="card-amount">{{ FinancialData.freeze_money }}</div>
          <div class="card-title">待结算 (元)</div>
          <div class="detail-btn" @click="handleClick('2')">明细</div>
        </div>
      </div>

      <div class="overview-card">
        <div class="card-content">
          <div class="card-amount">{{ FinancialData.income_withdrawed }}</div>
          <div class="card-title">已提现</div>
          <div class="detail-btn" @click="handleClick('3')">记录</div>
        </div>
      </div>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <div class="filter-title">收入/支出</div>
      <!-- 时间筛选 -->
      <div class="time-filter">
        <el-radio-group v-model="activeTimeFilter" size="small" @change="handleTimeChange">
          <el-radio-button v-for="(item, index) in dateType" :key="index" :label="item.date">{{ item.name
          }}</el-radio-button>
        </el-radio-group>
        <el-date-picker size="small" v-model="searchDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange"></el-date-picker>
        <el-radio-group v-model="activeTypeFilter" size="small" @change="handleTypeChange">
          <el-radio-button label="all">全部</el-radio-button>
          <el-radio-button label="1">收入</el-radio-button>
          <el-radio-button label="2">支出</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <!-- 明细表格 -->
    <el-table :data="financialDetails" :border="true" style="width: 100%;margin-bottom: 20px;">
      <el-table-column prop="type" label="明细" align="center">
      </el-table-column>
      <el-table-column label="收支来源" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no + scope.row.change_type }}
        </template>
      </el-table-column>
      <el-table-column prop="change_money" label="金额" align="center">
      </el-table-column>
      <el-table-column prop="create_time" label="时间" align="center"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize" :current-page="currentPage" @size-change="handleSizeChange"
      @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>

<script>
import {
  getTodayRange,
  getThisWeekRange,
  getThisMonthRange,
  getThisQuarterRange,
  getThisYearRange
} from '@/utils/monentDay.js'
export default {
  name: 'FinancialHome',
  data() {
    return {
      searchDate: [],// 日期范围
      dateType: [{
        name: '本日',
        id: "1",
        date: getTodayRange(),
      }, {
        name: '本周',
        id: "2",
        date: getThisWeekRange(),
      }, {
        name: '本月',
        id: "3",
        date: getThisMonthRange(),
      }, {
        name: '本季',
        id: "4",
        date: getThisQuarterRange(),
      }, {
        name: '本年',
        id: "5",
        date: getThisYearRange(),
      }],

      activeTimeFilter: {},
      activeTypeFilter: 'all',  //all 全部 1 收入 2 支出
      start_date: '',// 开始时间
      end_date: '', // 结束时间
      financialDetails: [],// 财务明细数据
      total: 0,// 总条数
      currentPage: 1,// 当前页码
      pageSize: 10,// 每页条数
      FinancialData: {
        freeze_money: 0,
        income_withdrawed: 0,
        income_withdrawing: 0,
        store_money: 0,
        total_income: 0,
        total_joindeposit: 0,
        total_joinfee: 0,
      },// 财务统计数据
    }
  },
  mounted() {
    this.getFinancialStats()
    this.getFinancialTable()
  },
  methods: {
    // 日期选择器改变事件
    handleDateChange() {
      // 取消快捷选项的选中状态
      this.activeTimeFilter = '';
      this.start_date = this.searchDate[0];
      this.end_date = this.searchDate[1];
      this.currentPage = 1;
      this.getFinancialTable();
    },
    // handleClick 处理点击事件
    handleClick(type) {
      switch (type) {
        case '1':
          this.$emit('goToComponent', 'Withdrawal', {
            money: this.FinancialData.store_money,
          });
          break;
        case '2':
          this.$emit('goToComponent', 'Settlement');
          break;
        case '3':
          this.$emit('goToComponent', 'WithdrawalHistory');
          break;
      }
    },
    // 处理时间筛选
    handleTimeChange(e) {
      this.activeTimeFilter = e;
      this.start_date = e.start;
      this.end_date = e.end;
      // 将日期回显到日期选择器
      this.searchDate = [e.start, e.end];
      this.currentPage = 1;
      this.getFinancialTable();
    },
    // 处理类型筛选
    handleTypeChange() {
      this.currentPage = 1;
      this.getFinancialTable()
    },
    // 获取财务统计
    getFinancialStats() {
      this.$api.getFinancialStats().then(res => {
        this.FinancialData = res;
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 获取财务列表
    getFinancialTable() {
      this.$api.getFinancialList({
        money_type: this.activeTypeFilter,
        start_time: this.start_date,
        end_time: this.end_date,
        page: this.currentPage,
        list_rows: this.pageSize,
      }).then(res => {
        this.financialDetails = res.data;
        this.total = res.total
      }).catch(err => {
        this.$message.error(err)
      })
    },
    // 分页相关
    handleSizeChange(val) {
      this.pageSize = val;
      this.getFinancialTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getFinancialTable();
    }
  }
}
</script>

<style scoped>
.financial-management {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 120px);
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.page-header .line {
  width: 4px;
  height: 20px;
  background-color: #286ced;
  margin-right: 12px;
}

.page-header .page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

/* 财务概览卡片 */
.financial-overview {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
}

.overview-card {
  flex: 1;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  position: relative;
}

.card-title {
  font-size: 14px;
  color: #666;
  margin-top: 16px;
}

.card-amount {
  font-size: 32px;
  font-weight: 700;
  color: #333;
}

.withdraw-btn {
  width: 40px;
  height: 20px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 0px;
  border: 1px solid #2563E5;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 500;
  font-size: 12px;
  color: #286CED;
  cursor: pointer;
}

.detail-btn {
  width: 40px;
  height: 20px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 0px;
  border: 1px solid #BFBFBF;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 500;
  font-size: 12px;
  color: #BFBFBF;
  cursor: pointer;
}

/* 筛选区域 */
.filter-section {
  background-color: #fff;
  border-radius: 8px;
}

.filter-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  text-align: left;
}

.time-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

/* 表格样式 */
::v-deep .el-table__header-wrapper th {
  background-color: #f5f7fa;
  font-weight: 600;
  color: #666;
  font-size: 14px;
  border-bottom: 1px solid #ebeef5;
}

::v-deep .el-table__body-wrapper td {
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #ebeef5;
}

/* 类型样式 */
.expense-type,
.withdraw-status {
  color: #f56c6c;
}

.income-type,
.settle-status {
  color: #67c23a;
}

.expense-amount {
  color: #f56c6c;
  font-weight: 500;
}

.income-amount {
  color: #67c23a;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .financial-overview {
    flex-direction: column;
  }

  .time-filter {
    flex-wrap: wrap;
    gap: 16px;
  }

  .type-filter {
    justify-content: flex-start;
  }
}
</style>